export default __webpack_public_path__ + "static/media/postgres.5c89246a.svg";